import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  // NOTE: withCredentials intentionally OFF.
  // Auth uses Bearer token from localStorage (see request interceptor below),
  // which works cross-origin against `Access-Control-Allow-Origin: *` responses.
  // Cookies would be blocked cross-domain (custom domain → api subdomain) anyway.
});

const TOKEN_KEY = "ugshil_admin_token";

// Auth strategy:
// 1. PRIMARY: httpOnly cookie set by backend on /auth/login (XSS-safe).
// 2. FALLBACK: Bearer token stored in localStorage — used only when the
//    browser blocks 3rd-party cookies (Safari ITP, strict-privacy Chrome).
//    This is an accepted XSS trade-off for cross-subdomain preview envs.

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

// Always inject the latest token from localStorage on every request.
// This is more robust than setting axios.defaults once, and handles cases
// where third-party cookies are blocked by the browser.
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 during an authenticated request, clear stale token so user
// re-authenticates cleanly.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      if (!url.endsWith("/auth/me") && !url.endsWith("/auth/login")) {
        localStorage.removeItem(TOKEN_KEY);
      }
    }
    return Promise.reject(err);
  },
);

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
